export const shadows = {
  subtleDark: '0 5px 25px rgb(0,0,0,0.05)',
};

export default shadows;
